// ── Watch-return bridge ───────────────────────────────────────────────────────
// The one streaming signal we actually own: you tapped "Watch on <service>".
// We stash that, and when you come back to NextEp a while later, offer to mark
// the episode you went to watch — closing the watched-it-there → tracked-it-here
// loop without any streaming API (Jason 2026-06-30).

const KEY = 'nextep_pending_watch'
export const MIN_AWAY_MS = 90 * 1000              // away < this = a bounce, not a watch
const MAX_AGE_MS = 6 * 60 * 60 * 1000             // older than this = stale, forget it

export function recordLaunch({ showId, showName, service }) {
  if (!showId) return
  try {
    localStorage.setItem(KEY, JSON.stringify({ showId, showName, service, ts: Date.now() }))
  } catch (e) {}
}

// Returns the pending launch if it exists and isn't stale (independent of MIN_AWAY,
// so the caller can distinguish a quick bounce from a real watch). null otherwise.
export function readPendingWatch() {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const p = JSON.parse(raw)
    if (!p?.showId || Date.now() - (p.ts || 0) > MAX_AGE_MS) { localStorage.removeItem(KEY); return null }
    return p
  } catch (e) { return null }
}

export function clearPendingWatch() {
  try { localStorage.removeItem(KEY) } catch (e) {}
}
